import React, { useState } from "react";
import {
  View,
  Linking,
  ScrollView,
  TouchableOpacity,
  Text,
  StyleSheet,
} from "react-native";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import { BackButton, Title, RedirectSelection } from "../../components/common";
import i18n from "@microdoing/shared/i18n";
import { askGDPRDeleteAccountRequest } from "@microdoing/shared/services/profileSettings/actions";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { Box } from "app/components/common/Box";
import ValidationModal from "app/components/common/ValidationModal";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import { breadCrumbsLegalScreen } from "app/navigation/breadcrumb/BreadcrumbPaths";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const LegalScreen = ({ navigation }) => {
  const [modalValidationVisible, setModalValidationVisible] = useState(false);

  const userId = useSelector(getUserId);
  const insets = useSafeAreaInsets();

  const dispatch = useDispatch();

  const navigatePolicy = () => {
    Linking.openURL("https://microdoing.com/privacy");
  };

  const askGDPRDeleteAccount = () => {
    dispatch(askGDPRDeleteAccountRequest({ userId }));
    setModalValidationVisible(false);
  };

  return (
    <WebDesktopView breadcrumbsPath={breadCrumbsLegalScreen}>
      <View style={[styles.container, { marginTop: insets.top }]}>
        <ValidationModal
          isVisible={modalValidationVisible}
          title={i18n.t("delete-account-modal-title")}
          callBackLeftButton={() => setModalValidationVisible(false)}
          callBackRightButton={askGDPRDeleteAccount}
          onClickOutside={() => setModalValidationVisible(false)}
          rightButtonColor="system.red.950"
        />
        {!isWebDesktop && (
          <View style={styles.headerView}>
            <BackButton style={styles.backButton} onPress={navigation.goBack} />
            <View style={styles.bottomHeader}>
              <Title style={styles.title}>{i18n.t("Legal")}</Title>
            </View>
          </View>
        )}
        <ScrollView contentContainerStyle={styles.scrollView}>
          <Box
            borderRadius={8}
            backgroundColor="neutral.white"
            style={styles.mainBox}
          >
            <RedirectSelection text="CGI" onPress={navigatePolicy} />
          </Box>
          <TouchableOpacity onPress={() => setModalValidationVisible(true)}>
            <Box
              borderRadius={8}
              backgroundColor="neutral.white"
              style={styles.mainBox}
            >
              <Text style={{ color: "red" }}>{i18n.t("delete-account")}</Text>
            </Box>
          </TouchableOpacity>
        </ScrollView>
      </View>
    </WebDesktopView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  mainBox: {
    alignSelf: "center",
    width: "90%",
    paddingHorizontal: 20,
    paddingVertical: 15,
    marginBottom: 15,
    flex: 1,
  },
  scrollView: {
    paddingBottom: 0,
  },
  bottomHeader: {
    alignSelf: "center",
    marginTop: 15,
    width: wp("90%"),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  backButton: {
    alignSelf: "flex-start",
  },
  headerView: {
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginTop: 10,
    width: wp("90%"),
    marginBottom: 20,
  },
  title: {
    textAlign: "left",
    fontSize: 30,
  },
});

export default LegalScreen;
